module.exports = __webpack_public_path__ + "images/emoji/arrow_backward.a745ab5717d06929f6c9.png";